export interface DialogColumn  {
  text: string
  value: string | null | undefined
}

export class DraggableShowHideDialog {
  private originalItemsList: DialogColumn[]

  constructor(initialItems: DialogColumn[]) {
    this.originalItemsList = initialItems
  }

  filterItemsByQuery(searchQuery: string): DialogColumn[] {
    if (!searchQuery) return this.originalItemsList

    const normalizedQuery = searchQuery.toLowerCase()

    return this.originalItemsList.filter(item =>
      (item.text || '').toLowerCase().includes(normalizedQuery) ||
      (item.value || '').toLowerCase().includes(normalizedQuery)
    )
  }

  updateOriginalItemsList(newItemsList: DialogColumn[]) {
    this.originalItemsList = newItemsList
  }

  normalizeColumns(columnsList: DialogColumn[]): DialogColumn[] {
    let aux_columnsList = structuredClone(columnsList)
    let ret = (aux_columnsList || []).map((column, index) => {
      const has_key = column.hasOwnProperty('key')
      const columnText = column && column.text ? String(column.text) : ''
      if (has_key) {
        column.value = column['key']
      }
      const rawValue = (column && column.value != null && column.value !== '') ? column.value : null
      if (rawValue === null && !has_key) {
        column.value = String(columnText + '__' + index)
      }
      return column
    })
    return ret
  }

  formatColumnsCSV(columnsList) {
    let aux_columnsList = structuredClone(columnsList)
    let ret = (aux_columnsList || []).map((column) => {
      const has_key = column.hasOwnProperty('key')
      const has_value = column.hasOwnProperty('value')
      if (has_key && has_value) {
        delete column.value
      }
      return column
    })
    return ret
  }

  toggleSelection(selectedValues: string[], columnValue: string): string[] {
    const selectedIndex = selectedValues.indexOf(columnValue)
    if (selectedIndex === -1) return [...selectedValues, columnValue]
    const next = [...selectedValues]
    next.splice(selectedIndex, 1)
    return next
  }

  moveSelected(
    source: DialogColumn[],
    target: DialogColumn[],
    selectedValues: string[],
  ): { source: DialogColumn[]; target: DialogColumn[] } {
    const selectedSet = new Set(selectedValues)
    const movingColumns = source.filter(column => selectedSet.has(String(column.value)))
    const newSource = source.filter(column => !selectedSet.has(String(column.value)))
    const newTarget = target.concat(movingColumns)
    return { source: newSource, target: newTarget }
  }

  toggleAll(list: DialogColumn[], currentSelected: string[]): string[] {
    const allSelected = list.length > 0 && currentSelected.length === list.length
    return allSelected ? [] : list.map(column => String(column.value))
  }
}
